export default {
  VIEW_ELEMENT: '@WS_EDITOR/VIEW_ELEMENT',
};
